import { Component, EventEmitter, Input, Output, ViewChild, OnInit, OnDestroy } from '@angular/core'
import { environment } from 'src/environments/environment'
import { FormData, Step } from '../../interfaces'
import { FormCustomerInfoComponent } from './components/form-customer-info/form-customer-info.component'
import { FormPaymentComponent } from 'src/app/shared/form-payment/form-payment.component'
import { FormShippingAddressComponent } from './components/form-shipping-address/form-shipping-address.component'
import Regions from 'src/app/data/regions'
import { TShippingName, IShipping } from 'src/app/data/shipping/types'
import { DiscountService } from 'src/app/services/discount.service'
import { IDiscountCampaign } from 'src/app/services/discount.service/discount.interfaces'
import Subscriber from 'src/app/subscriber'
import { FEToBEShipping } from 'src/app/functions'
import { getShippingDiscount, calculateDiscount } from 'src/app/services/discount.service/discount.functions'
import { BookInOrder } from '@functions/interfaces'

enum SUMMARY {
  email = 'E-mail address',
  address = 'Billing Address',
  shippingAddress = 'Shipping address',
  shippingMethod = 'Shipping Method'
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  @Input() step: Step['id'];

  @Output() stepChange: EventEmitter<Step['id']>;

  @Input() books!: BookInOrder[];

  @Output() dataChange: EventEmitter<FormData>;

  @Input() disabledShippingNames: TShippingName[];

  @Input() shippings: IShipping[];

  @Input() set shipping(name: IShipping) {
    this.formShippingMethod = name
  }

  @Input() isNextDisabled: boolean = false;

  @Output() nextClick = new EventEmitter<void>();

  @ViewChild(FormCustomerInfoComponent)
    public formCustomerInfoComponent: FormCustomerInfoComponent

  @ViewChild(FormShippingAddressComponent)
    public formShippingAddressComponent: FormShippingAddressComponent

  @ViewChild(FormPaymentComponent)
    public formPaymentComponent: FormPaymentComponent

  public formCustomerInfo: FormData['formCustomerInfo']
  public formShippingAddress: FormData['formShippingAddress']
  public formShippingAddressActive: FormData['formShippingAddressActive'] = true // * active means checkbox
  public formShippingMethod: FormData['formShippingMethod']
  public formPayment: FormData['formPayment']

  public activeDiscountCampaign?: IDiscountCampaign;

  public readonly SUMMARY = SUMMARY;

  public readonly environment = environment;

  private readonly _sub = new Subscriber();

  // * summary getters
  get summaryEmail(): string {
    const form = this.formCustomerInfo
    const arr: string[] = []

    if (form) {
      arr.push(form.email)
    }

    return arr.join(' ')
  }

  get summaryAddress() {
    let str = '';
    const form = this.formCustomerInfo;

    if (form) {
      const region = Regions[form.addressFirst];

      str = `
        〒${form.postalCodeFirst}-${form.postalCodeSecond}<br>
        ${region?.name} ${form.addressSecond} ${form.addressThird}<br>
        ${form.lastName} ${form.firstName}さま<br>
        ${form.phoneFirst}-${form.phoneSecond}-${form.phoneThird}
      `;
    }

    return str;
  }

  get summaryShippingAddress() {
    let str = '';
    const form = this.formShippingAddressActive ?
      this.formCustomerInfo : this.formShippingAddress

    if (form) {
      const region = Regions[form.addressFirst];

      str = `
        〒${form.postalCodeFirst}-${form.postalCodeSecond}<br>
        ${region?.name} ${form.addressSecond} ${form.addressThird}<br>
        ${form.lastName} ${form.firstName}さま<br>
        ${form.phoneFirst}-${form.phoneSecond}-${form.phoneThird}
      `;
    }

    return str;
  }

  get summaryShippingMethod(): string {
    const form = this.formShippingMethod

    const arr: string[] = []

    if (form) {
      const shipping = form

      if (shipping) {
        const { activeDiscountCampaign } = this;
        const shippingMethod = FEToBEShipping(shipping);
        let shippingPrice = shipping.price;

        const shippingDiscount = activeDiscountCampaign && getShippingDiscount(activeDiscountCampaign, shippingMethod);

        if (shippingDiscount) {
          shippingPrice = calculateDiscount(shippingPrice, shippingDiscount);
        }

        arr.push(shipping.name.replace(' Shipping', ' ·'))
        arr.push(`${shipping.currency}${shippingPrice} (税込)`)
      }
    }

    return arr.join(' ')
  }

  get summaryShow(): boolean {
    return !!(
      this.summaryEmail ||
      this.summaryAddress ||
      this.summaryShippingAddress ||
      this.summaryShippingMethod
    ) && this.step !== 1
  }

  constructor(
    private _discountService: DiscountService,
  ) {
    this.dataChange = new EventEmitter()
    this.stepChange = new EventEmitter()
  }

  ngOnInit() {
    this._sub.push(
      this._discountService.activeDiscountCampaignsObservable
        .subscribe((discountCampaign) => {
          this.activeDiscountCampaign = discountCampaign;
        }),
    )
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  public onChange() {
    const data: FormData = {
      formCustomerInfo: this.formCustomerInfo,
      formShippingAddress: this.formShippingAddress,
      formShippingAddressActive: this.formShippingAddressActive,
      formShippingMethod: this.formShippingMethod,
      formPayment: this.formPayment
    }

    this.dataChange.emit(data)
  }

  public summaryOnChange(key: SUMMARY): void {
    console.log('change', key)

    switch (key) {
      case SUMMARY.shippingMethod:
        this.stepChange.emit(2)
        break
      default:
        this.stepChange.emit(1)
        break
    }
  }

  /**
   * filling the customer info form group with test data
   */
  public fillCustomerInfo(
    data: Partial<FormData['formCustomerInfo']> = {}
  ): void {
    this.formCustomerInfoComponent.formGroup.setValue(Object.assign(
      this.formCustomerInfoComponent.formGroup.value || {},
      data,
    ));
  }
}
